import { cleanURL } from "../../../lib/utils";
import { useLocation } from "react-router-dom";
import { TLeftMenuProps, TMenuCustomCSSClasses } from "./types";

export const LeftMenu = ({ optionList, customCSSClasses }: TLeftMenuProps) => {
    const { pathname } = useLocation();
    const clearedPathName = `/${cleanURL(pathname)}`;

    const defaultClickHandler = (
        e: React.MouseEvent<HTMLLIElement, MouseEvent>,
        customClickHandler?: () => void
    ) => {
        e.preventDefault();
        e.stopPropagation();
        if (customClickHandler) customClickHandler();
    };

    const currCSSClasses: TMenuCustomCSSClasses = {
        active: customCSSClasses?.active || "active",
        menuList: customCSSClasses?.menuList || "",
        menuItem: customCSSClasses?.menuItem || "",
    };

    return (
        <ul
            className={`list-group list-group-flush ${currCSSClasses.menuList}`}
        >
            {optionList.map((l) => (
                <li
                    key={"li-" + l.label}
                    className={`list-group-item my-1 d-inline-flex p-2 ${
                        customCSSClasses?.menuItem
                    } ${
                        clearedPathName === l.pathName
                            ? currCSSClasses.active
                            : ""
                    }`}
                    onClick={(e) => {
                        defaultClickHandler(e, l.clickHandler);
                    }}
                    role="button"
                >
                    <button className="col-1 btn btn-link menu-item-text-color">
                        <i className={l.iconClass + ""} />
                    </button>
                    <button className="btn btn-link fw-bold ms-2 menu-item-text-color">
                        {l.label}
                    </button>
                </li>
            ))}
        </ul>
    );
};
